import { FC } from "react";

import { FoodBusinessForm } from "../HubspotForms";

type PageFormProps = {
  buttonLabel: string;
};

const PageForm: FC<PageFormProps> = ({ buttonLabel }) => {
  return (
    <section className="relative z-10 isolate flex w-full flex-col items-center px-[120px] py-[100px] bg-[#F8F8F8]">
      <h3 className="w-full text-[36px] font-raleway font-bold text-primaryDark-0 text-center mb-[24px]">
        <span className="text-primaryDark-400"> Join </span> HomeCook's
        Community Now!
      </h3>

      <div className="w-full max-w-[525px] mx-auto">
        <FoodBusinessForm submitLabel={buttonLabel} />
      </div>
    </section>
  );
};

export default PageForm;
